import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import HeroSection from './components/HeroSection';
import TimelineBar from './components/TimelineBar';
import WhoForSection from './components/WhoForSection';
import WhyLLCSection from './components/WhyLLCSection';
import ThreePhasesSection from './components/ThreePhasesSection';
import ComparisonSection from './components/ComparisonSection';
import CreditSection from './components/CreditSection';
import LLCFAQSection from './components/LLCFAQSection';
import LLCCTASection from './components/LLCCTASection';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import AnimatedSection from '../../components/base/AnimatedSection';
import { useLanguageFromPath } from '../../hooks/useLanguageFromPath';
import i18n from '../../i18n';
import { SITE_ORIGIN } from '@/config/siteUrl';

export default function StartLLCPage() {
  useLanguageFromPath();
  const { t } = useTranslation();
  const isEs = i18n.language === 'es';

  useEffect(() => {
    const canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    const hreflangEn = document.querySelector('link[hreflang="en"]') as HTMLLinkElement | null;
    const hreflangEs = document.querySelector('link[hreflang="es"]') as HTMLLinkElement | null;
    const hreflangX = document.querySelector('link[hreflang="x-default"]') as HTMLLinkElement | null;

    if (isEs) {
      document.title = 'Iniciar tu LLC | Crédito Empresarial y Financiamiento al 0% | Kailac';
      const metaDesc = document.querySelector('meta[name="description"]');
      if (metaDesc) metaDesc.setAttribute('content', '¿Sin LLC todavía? Kailac guía a emprendedores desde la formación de la LLC hasta la construcción de crédito empresarial y el acceso a programas de financiamiento al 0% de interés. Sin entidad requerida para empezar. Asesoría experta bilingüe EN/ES.');
      if (canonical) canonical.setAttribute('href', `${SITE_ORIGIN}/es/inicia-tu-llc`);
      if (hreflangEn) hreflangEn.setAttribute('href', `${SITE_ORIGIN}/start-your-llc`);
      if (hreflangEs) hreflangEs.setAttribute('href', `${SITE_ORIGIN}/es/inicia-tu-llc`);
      if (hreflangX) hreflangX.setAttribute('href', `${SITE_ORIGIN}/start-your-llc`);
    } else {
      document.title = 'Start Your LLC | Build Business Credit & Get Funded | Kailac';
      const metaDesc = document.querySelector('meta[name="description"]');
      if (metaDesc) metaDesc.setAttribute('content', 'No LLC yet? Kailac guides entrepreneurs from LLC formation to building business credit and accessing 0% interest funding programs. Start with no entity required. Expert bilingual advisory. EN/ES.');
      if (canonical) canonical.setAttribute('href', `${SITE_ORIGIN}/start-your-llc`);
      if (hreflangEn) hreflangEn.setAttribute('href', `${SITE_ORIGIN}/start-your-llc`);
      if (hreflangEs) hreflangEs.setAttribute('href', `${SITE_ORIGIN}/es/inicia-tu-llc`);
      if (hreflangX) hreflangX.setAttribute('href', `${SITE_ORIGIN}/start-your-llc`);
    }
  }, [isEs]);

  return (
    <div className="min-h-screen bg-[#FCFAFD] pb-16 lg:pb-0">
      <Navbar />
      <main>
        {/* Hero — no animation wrapper, should appear instantly */}
        <HeroSection />

        <AnimatedSection delay={0}>
          <TimelineBar />
        </AnimatedSection>

        <AnimatedSection delay={0}>
          <WhoForSection />
        </AnimatedSection>

        <AnimatedSection delay={0}>
          <WhyLLCSection />
        </AnimatedSection>

        <AnimatedSection delay={0}>
          <ThreePhasesSection />
        </AnimatedSection>

        <AnimatedSection delay={0}>
          <ComparisonSection />
        </AnimatedSection>

        <AnimatedSection delay={0}>
          <CreditSection />
        </AnimatedSection>

        <AnimatedSection delay={0}>
          <LLCFAQSection />
        </AnimatedSection>

        <AnimatedSection delay={0}>
          <LLCCTASection />
        </AnimatedSection>
      </main>
      <Footer />
    </div>
  );
}
